import { InjectionToken } from '@angular/core';
import { LocalCache } from '@nk/caching-lib';
import { DataSourceCategoryEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface DataSourceApiService {
  dataSourceAvailableYearCache: LocalCache<
    DataSourceApiService,
    (dataSourceIdentifier: string, companyUuid?: string, shareholderCompanyUuid?: string) => Observable<number[]>
  >;
  fetchDataSourceAvailableYear(
    dataSourceIdentifier: string,
    companyUuid?: string,
    shareholderCompanyUuid?: string,
  ): Observable<number[]>;
  dataSourceCategoryListCache: LocalCache<
    DataSourceApiService,
    (dataSourceDomainKey?: string) => Observable<DataSourceCategoryEntity[]>
  >;
  fetchDataSourceCategoryList(dataSourceDomainKey?: string): Observable<DataSourceCategoryEntity[]>;
}
export const DATA_SOURCE_API_SERVICE_TOKEN = new InjectionToken<DataSourceApiService>('DataSourceApiService');
